import TeachersChatView from "./Teachers";
import StudentsChatView from "./Students";
import FamiliesChatView from "./FamilyMembers";

const ChatViewRoutes = [TeachersChatView, StudentsChatView, FamiliesChatView];

export default ChatViewRoutes;
